const plTranslation = {
  "Enter the Project": "Wejdź do projektu",
  "Click anywhere to activate sound":
    "Kliknij gdziekolwiek, aby włączyć dźwięk",
  "Skip the intro": "Pomiń intro",
  "See What`s Next": "Zobacz co dalej",
  Overgrowth: "Zarastanie",
  Magic: "Magia",
  Home: "Dom",
  Community: "Społeczeństwo",
  Childhood: "Dzieciństwo",
  "Discover the Archive": "Odkryj archiwa",
  Instructions: "Instrukcja",
  "about 5 minutes": "ok. 5 minut",
  magicContent:
    "<i>Magia</i> to ścieżka przenosząca słuchacza prosto na rozgrzaną słońcem drogę między domami we wsi Mikołajów. To obraz pachnący spotkaniami pod orzechem u sąsiada Lisa. Brzmiący rozmowami na ławeczkach przed domem i wieczornymi koncertami na harmonię i piszczałkę. Obraz innego świata, który do dzisiaj wraca w snach do dawnych mieszkańców wsi.",
  homeContent:
    "Ścieżka <i>dom</i> to perspektywa rodzinnych więzi, które powstawały w Mikołajowie. To historie urodzin, ślubów i wspólnej budowy nowych domów. Aż do momentu kiedy nowe domy nie mogły już powstawać, w okolicy zaczęło pachnieć siarką, i <i>tak było smutno</i> bo wszystkie te rodzinne historie musiały zostać przeniesione do innego miejsca. I chociaż <i>najważniejsza jest rodzina, a nie cegły</i>, to jednak pozostaje tęsknota.",
  communityContent:
    "Ścieżka <i>społeczeństwo</i> to opowieści o spotkaniach i o więzi, która zachowała się między mieszkańcami wsi. Najpierw o spotkaniach na zabawach, na których Grabowski zawsze grywał, a baby hulały. Potem o tym kto we wsi dłużej został, a kto wyjechał pierwszy. W końcu o tych ostatnich spotkaniach, na które nadal zjeżdżają się wszyscy mieszkańcy Mikołajowa - o pogrzebach.",
  childhoodContent:
    "W ścieżce <i>dzieciństwo</i> wieś Mikołajów zobaczyć można oczami dzieci. Tych starszych, które dzieciństwo spędziły na wchodzeniu w kałuże i na zabawie fajerką. I tych młodszych, dziś 40-letnich, które pamiętają już pierwsze walkmany przywiezione przez wuja z Ameryki i dyskoteki organizowane w domach opuszczonych przez przesiedlonych sąsiadów.",
  "journey to the church fair in sulisławice":
    "wyjazd na odpust w sulisławicach",
  "Photo: Archive of Mrs. Henryka Thomas": "zdj: archiwa Pani Henryki Tomtas",
  ArchiveFirstContentLeft: `Rok 1956 - Wichrowie z sąsiadami jadą na Odpust do Sulisławic. Z przodu powozi Stefan Wicher, obok Jan Nowak. Na tylnym siedzeniu od prawej - Janina Wichrowa i Anna Nowak.`,
  ArchiveFirstContentRight: `Stoją: w czapce - Boguś Wicher (10 lat) i Wiesiek Nowak. W głębi zabudowania Skroków, na prawo niewidoczny budynek szkoły w Mikołajowie.`,
  "Turn the Photo Over": "Odwróć zdjęcie",
  "Childhood in Mikołajów": "dzieciństwo w mikołajowie",
  "Mikołajów, 1980s": "MIKOŁAJÓW | lata 90.",
  ArchiveSecondContentLeft1:
    "Dzieci nie miały zabawek. W jesienne i zimowe wieczory bawiły się porąbanym do palenia drewnem. Budowały domy i studnie. Cieszyły się jak znalazły jakiś ładny, wystrugany kawałek.",
  ArchiveSecondContentRight1:
    "Najpiękniejszą zabawkę jaką tatuś zrobił dla Bogusia był drewniany, drabiniasty wózek. Boguś miał dużo radości, kiedy w tym wózku ciągnął go nasz duży pies!",
  ArchiveSecondContentLeft2:
    "My - starsze dzieci, sami robiliśmy sobie piłki z bydlęcej sierści. Pasąc krowy zbieraliśmy sierść z ich grzbietów i toczyliśmy w rękach kulki. Takie piłki tworzyły się przez kilka tygodni, ale były lepsze od szmacianych.",
  ArchiveSecondContentRight2:
    "Często nie było czasu na tworzenie piłki, bo pasąc krowy trzeba się było uczyć lub czytać lektury szkolne.",
  ArchiveSecondContentLeft3:
    "Trzeba było obrobić gospodarkę, dopiero można było się iść bawić. Mój tata zmarł jak miałam 9 lat i od tamtego czasu, razem z bratem pomagaliśmy w polu mamie.",
  ArchiveSecondContentRight3:
    "Nie miałam czasu, tak jak wszystkie dzieci, aby swobodnie biegać po podwórku. Mieliśmy konia, krowę, świnkę, króliki, kury, kaczki, indyki - całe mnóstwo.",
  ArchiveSecondContentLeft4:
    "Zabawy były na przykład na drogach, wychodziliśmy i graliśmy w piłkę na tych drogach. Po deszczu zawsze skakaliśmy po kałużach.",
  ArchiveSecondContentRight4:
    "Graliśmy też w zbijanego, rysowaliśmy gry na piasku. Fajnie było...",
  archive: "archiwum",
  ArchiveFourTitle: "Mikołajów: moment wysiedlenia",
  ArchiveFourContentLeft1:
    "Mieszkanie mieliśmy ciasne, ale byliśmy w nim szczęśliwi. W jednym łóżku spaliśmy we troje, czasem w czworo (przyp. z rodzeństwem), ale nikt nie narzekał, że jest mu ciasno. Latem wychodziliśmy spać do stodoły, na siano.",
  ArchiveFourContentRight1:
    "Było nam dobrze i wesoło. Lekcje odrabialiśmy przy jednym stole, a jesienią i zimą przy lampie naftowej (...).",
  ArchiveFourContentLeft2:
    "Z tamtych lat pamiętam mamusię stale krzatającą się przy kuchni. Pamiętam jak piekła chleb, a dla nas - dzieci, podpłomyki ze śmietaną i cukrem. Pamiętam jak ciężko było jej prać w balii z żelazną tarą.",
  ArchiveFourContentRight2: `Pamiętam jak przędła nici z wełny, a w jesienne i zimowe wieczory robiła nam sweterki na drutach.`,
  ArchiveFourContentLeft3:
    "Tatuś dużo czasu spędzał przy warsztacie, który był w drugiej niewykończonej izbie. Robił na zamówienie drzwi lub ramy okienne, aby zarobić pieniądze.",
  ArchiveFourContentRight3:
    "Ten kredens robił tatuś. Lubił siedzieć w tym miejscu przy stole.",
  ArchiveFourContentLeft4: `W pierwszej izbie upłynęło moje dzieciństwo i młodość. W tej izbie w dniu 3 .10.1997 r., ze łzami w oczach żegnałam się z domem, z jego otoczeniem, z Mikołajowem.`,
  ArchiveFourContentRight4: `Chcąc zachować w pamięci jego obraz i przeżyte piękne lata z rodzicami i rodzeństwem. Nigdy już nie odwiedziłam Mikołajowa.`,
  "mining today": "kopalnia współcześnie",
  ArchiveThirdSection1Content: ` Charakterystyka funkcjonowania kopalni na przestrzeni lat uległa znaczącej zmianie, a współczesne, nowe technologie pozwalają na wyraźne ograniczenie szkodliwego wpływu na środowisko naturalne. Kopalnia Osiek to doskonały przykład na działanie nowoczesnej, małoinwazyjnej formy wydobycia, która wraz ze skutecznie przeprowadzonym procesem rekultywacji pozwala na przywrócenie równowagi w otoczeniu infrastuktury kompleksu.`,
  ArchiveThirdSection1Description: `Kopia cyfrowa ze zbiorów Archiwum Państwowego w Kielcach Oddział Zamiejscowy w Sandomierzu, Kopalnie i Zakłady Przetwórcze Siarki "Siarkopol" w Tarnobrzegu, sygn. 24/1142`,
  ArchiveThirdSection2Description: "wywiad z przedstawicielem kopalni osiek",
  ArchiveThirdSection2Content:
    "Czy na przestrzeni lat nastąpił rozwój i poprawa zarówno w oddziaływaniu kopalni na okoliczne tereny, jak i skuteczność procesów rekultywacji?",
  ArchiveThirdSection4Content: `W latach 1969 – 1992 wydobywano siarkę w kopalni "Machów" metodą odkrywkową, która polegała na usunięciu warstw skalnych zalegających nad kopaliną użyteczną (siarką) oraz na wybieraniu odsłoniętego w ten sposób złoża siarki w otwartym wyrobisku. Na skutek wieloletniej działalności górniczej została wybrana naturalna warstwa izolacyjna oddzielająca dwa poziomy wodonośne: trzeciorzędowy (zmineralizowany, zawierający siarkowodór) i czwartorzędowy.`,
  ArchiveThirdSection5Content: `Konieczne było prowadzenie odwodnienia wyrobiska, ponieważ kontakt wód trzeciorzędowych z powietrzem sprzyjałby wydzielaniu się siarkowodoru, który stanowiłby zagrożenie dla otaczających kopalnię form życia biologicznego. Ostatecznie eksploatacja siarki w kopalni "Machów" pozostawiła po sobie 560 ha wyrobiska o głębokości od 80 do 100 m oraz 860 ha zwałowiska zewnętrznego. W procesie rekultywacji i likwidacji odkrywki udało się opracować metodę, która zagwarantowała bezpieczeństwo naturalne i w efekcie w tym miejscu powstało Jezioro Tarnobrzeskie.`,
  ArchiveThirdSection5Content2: `Z kolei kopalnia siarki "Osiek" od 1993 roku prowadzi wydobycie siarki metodą otworową, która jest zdecydowanie mniej inwazyjna dla środowiska przyrodniczego aniżeli metoda odkrywkowa. Generalnie metoda ta polega na dostarczeniu do złoża ciepła, którego nośnikiem jest woda o temp. około 160 st. C, wytopieniu siarki, a następnie jej wypompowaniu na powierzchnię za pomocą sprężonego powietrza. Na potrzeby wydobycia wykorzystywany jest obszar tylko w rejonie otworów eksploatacyjnych i niezbędnej infrastruktury technicznej.`,
  ArchiveThirdSection7Content:
    "Zaletą tego typu eksploatacji jest także to, że zajęcie terenu jest czasowe, ograniczone maksymalnie do kilku miesięcy. Co bardzo ważne technologia wydobycia siarki ze złoża Osiek oparta jest o zamknięty obieg wód złożowych i technologicznych co oznacza, że wody te nie przedostają się do środowiska. Na terenie kopalni stosuje się również instalacje chemisorpcji, która ogranicza emisję siarkowodoru i oparów siarki do atmosfery znad zbiorników, do których trafia siarka zaraz po jej wytopie.",
  ArchiveThirdSection8Content: `Dla porównania w latach 1966-1996 prowadzono otworowe wydobycie siarki w kopalni "Grzybów". Jednak tam technologia wydobycia była oparta na obiegu otwartych wód technologicznych i złożowych co miało istotny wpływ na stan środowiska. Wodę niezbędną do wydobycia siarki pobierano z cieków powierzchniowych. Silnie zanieczyszczone wody z odprężania złoża kierowano do oczyszczalni, skąd po częściowym usunięciu zanieczyszczeń wracały do cieków powierzchniowych.`,
  ArchiveThirdSection8Content2: `Opary siarki znad zbiorników polowych, w których gromadzono surowiec emitowane były bezpośrednio do atmosfery. Można zauważyć, że kopalnie istotnie mają wpływ na środowisko przyrodnicze. Można tak dopracować technologię wydobycia, aby maksymalnie ograniczyć wpływ funkcjonowania kopalni na otaczające środowisko czego doskonałym przykładem jest Kopalnia Siarki "Osiek"`,
  "Mikołajow, 1970s": "Lata 70. Mikołajów",
  "Mikołajów, 2021": "2021 r. Mikołajów",
  "Start your Journey": "rozpocznij podróż",
  "The Story of Mikołajów": "Historia Mikołajowa",
  "About the Project": "o projekcie",
  Interviewees: "bohaterowie",
  Team: "Zespół",
  "vnLab page": "STRONA VNLAB",
  TheStoryOfMikołajów1:
    "Mikołajów to wieś istniejąca kiedyś w województwie świętokrzyskim. Położona na trasie Osiek-Połaniec. Wysiedlona pod budowę Kopalni Siarki Osiek. Proces wysiedleń rozpoczął się w latach 60. XX w. i trwał do lat 90. XX w.",
  TheStoryOfMikołajów2: `"Na początku wsi stały domy po obu stronach drogi, dalej - już tylko po prawej stronie. Wieś była położona na wzniesieniu, jakby pagórku, który wznosił się za domami aż do szosy, a obniżał przed domami, tworząc równinę w stronę Wisły. Do Wisły było ok. 1-1,5 km. Wieś Mikołajów tworzyła zabudowę liniową. Domy ustawione były tak, że ściany szczytowe były równoległe do drogi, a wejście było od południa. Domy budowane później, miały wejścia także z innej strony" (źródło: archiwum Henryki Tomtas).`,
  "18thCenturyTitle": " XVIII w.",
  "18thCenturyContent": `
  Niemcy zasiedlają wieś. "Jak podaje Słownik Geograficzny Królestwa Polskiego, w 1845 r. wieś zasiedlona została przez osadników niemieckich, prawdopodobnie po najazdach szwedzkich. Niemcy zbudowali w Mikołajowie budynek, który był domem modlitw (byli wyznania protestanckiego) i jednocześnie szkołą podstawową" (źródło: archiwum Henryki Tomtas).
  `,
  "1944Title": "1944 r.",
  "1944Content": `
  Polacy zasiedlają wieś. "Po wojnie, w 1944 r., Niemców przesiedlono z Mikołajowa do Mokoszyna, a później umożliwiono im wyjazd do Niemiec. Ich duże, zwykle 15 morgowe gospodarstwo zwykle dzielono na dwie części. Nowi, polscy właściciele dostawali działki po 7,5 morgi (mówiono: półosmówki) z domem lub ze stodołą. Anna Nowakowa - nasza sąsiadka, wspomina Niemców z Mikołajowa, bo mając 12 lat mieszkała u swojej siostry (od ok. 1937 r.), mówi, że pięknie mówili po polsku, bo w szkole uczyli się języka polskiego i niemieckiego" (źródło: archiwum Henryki Tomtas). `,
  "1960sTitle": "lata 60. XX w.",
  "1960sContent": `
  Bohaterki wywiadów wskazują lata 60. jako czas, w którym rozpoczęły się pierwsze odwierty siarki (mogło być to jedynie badanie terenu i sprawdzanie czy występują tam na tyle duże złoża siarki rodzimej, że będzie można wybudować kopalnię). 
  `,
  "1970sTitle": "lata 70. XX w.",
  "1970sContent":
    "Bohaterki wywiadów podają ten okres jako czas, w którym wprowadzono zakaz budowy nowych zabudowań. Można to uznać za początek wysiedleń, ponieważ wieś nie była już rozwijana, nie prowadzono tu żadnych inwestycji, a ludziom życie utrudniały maszyny, które były porozkładane na okolicznych polach. Z powodu odrzucanych pozwoleń na budowę nowych budynków, wszyscy mieszkańcy zaczęli przeczuwać, że wieś będzie przeznaczona do wysiedlenia.",
  "1986Title": "1986 r.",
  "1986Content": "Oficjalny początek budowy Kopalni Siarki.",
  "1992Title": "1992 r.",
  "1992Content": "Decyzja wojewody tarnobrzeskiego o wysiedleniu",
  "1995Title": "1995 r.",
  "1995Content":
    "Proces wysiedlenia ukończony w 90 %. Pozostałe 10 % ukończono w dwóch etapach: roku 2002 oraz 2006.",
  "2010Title": "2010 r.",
  "2010Content": `
  We wsi do ok. 2010 r. zostali trzej uparci mieszkańcy, którzy pomimo braku modernizacji wsi (brak elektryczności, dostępu do bieżącej wody) pozostali w swoich domostwach. 
  Po śmierci ostatniego "osadnika" Mikołajowa wieś przestała istnieć.`,
  "2022Title": "2022 r.",
  "2022Content": `Budowa nowej Kopalni Siarki na terenie Mikołajowa to nie tylko wysiedlenia i historie mieszkańców tęskno patrzących w przeszłość, ale też otwarcie kolejnych drzwi z nowymi możliwościami. Była to szansa na planowanie nowego życia — czy lepszego? Każdy z mieszkańców musi sobie już sam na to pytanie odpowiedzieć. Na pewno innego, ale również dającego szersze perspektywy i możliwości, zwłaszcza dla młodej społeczności Mikołajowa. Nowe miejsca pracy, dynamiczny rozwój regionu, możliwość pozostania bez konieczności wyjazdu w poszukiwaniu pracy — to tylko jedne z licznych, pozytywnych aspektów powstawania kopalni. Świat się, zmienia otoczenie się zmienia, ale jedno pozostaje niezmienne — wspomnienia byłych mieszkańców i pamięć o wsi Mikołajów. 
`,
  TheFutureTitle: "przyszłość",
  TheFutureContent:
    "Poniżej znajduje się fragment wywiadu z pracownikiem Kopalni Siarki, w którym opowiada o przyszłości terenu dawnego Mikołajowa.",
  AboutProjectSection1Content:
    "W zeszłym roku wróciło do mnie wspomnienie z&nbsp;dzieciństwa. We wspomnieniu zbierałam jabłka w sadzie razem z moją siostrą i szwagrem. Obraz był tak wyraźny, że postanowiłam to miejsce odnaleźć.",
  AboutProjectSection1Content2:
    "Jednak sad ze wspomnienia już nie istnieje. Tak samo jak wieś, w której się znajdował.",
  AboutProjectSection2Content:
    "Zarastanie to interaktywny projekt dokumentalny o&nbsp;ludziach, którzy w latach 90* zostali wysiedleni ze wsi Mikołajów pod budowę Kopalni Siarki Osiek. ",
  AboutProjectSection3Content:
    "Wioska, która została wysiedlona obecnie całkowicie zanika. Poprzez ten interaktywny projekt chcemy dać wsi nowe życie i ocalić ją od zapomnienia, a także zachęcić młodych ludzi do odkrywania lokalnych historii i własnych korzeni. ",
  
  AboutProjectSection5Content:
    "Tytuł projektu zarastanie nawiązuje do cykliczności trwania przestrzeni i zarastania wysiedlonych terenów, które być może w przyszłości zostaną ponownie zasiedlone.",
  AboutProjectSection2Content1: "*Proces wysiedeń trwał od lat 60.",
  AboutProjectSection6Content:
    "Projekt został przedstawiony w formie obumierającego domu, składającego się z trzech pokoi.",
  AboutProjectSection6Content2:
    "Dom jest metaforą wsi, a pokoje symbolizują trzy przestrzenie czasowe: przeszłość, wysiedlenie, teraźniejszość.",
  AboutProjectSection6Content3: `Z każdym etapem wieś, coraz bardziej "zarasta", aż staje się tęsknym wspomnieniem, a jej obraz funkcjonuje jedynie w głowie byłych mieszkańców.`,
  AboutProjectSection6Content4:
    "Dom można eksplorować za pomocą czterech ścieżek, które pokazują historię Mikołajowa z różnych perspektyw. Każda z nich prowadzi przez wszystkie pokoje i pozwala odkryć kolejne etapy zanikania wsi.",
  Characters: "Bohaterowie",
  CharactersSection1Title: "Henryka Tomtas i Mieczysława Dziuba",
  CharactersSection1Content: `Henryka Tomtas (po lewej) wraz z siostrą Mieczysławą.
  Razem wychowywały się w Mikołajowie. Henryka
  wyprowadziła się z Mikołajowa w latach 70., po
  skończeniu Kolegium Nauczycielskiego, ale nadal
  odwiedzała wieś i darzy ją niezwykłym sentymentem.
  Mieczysława wraz z rodziną wyprowadziła się z
  Mikołajowa w latach 90. do miejscowości Staszów.`,
  CharactersSection2Title: " Anna Nowak i Teresa Wyrzykowska",
  CharactersSection2Content: ` Anna Nowak (po lewej) wraz z córką Teresą. Anna Nowak
  była jedną z ostatnich mieszkanek Mikołajowa.
  Wyprowadziła się pod koniec lat 90. Do 2021 roku
  mieszkała wraz z córką Teresą w Osieku. Zmarła w 2022
  r., w wieku 99 lat.`,

  CharactersSection3Title: "Teresa Okoń i Danuta Serwan",
  CharactersSection3Content: ` Teresa Okoń (po lewej) wraz z córką Danutą. Bohaterki
  doskonale pamiętają moment wyprowadzki z Mikołajowa,
  ponieważ ich dom jako jeden z ostatnich został
  "wykupiony przez Siarkę". Do nowego miejsca
  zamieszkania przybyły w 1997 roku i jak wspominają:
  "Od razu poszłyśmy na wał, układać worki z piaskiem,
  bo była powódź".`,

  CharactersSection4Title: "Bożena Żugaj",
  CharactersSection4Content: `Z Mikołajowa wyprowadziła się w latach 80. do
  Tarnobrzega. Wieś kojarzy jej się głównie z weselem,
  które miała tam wspólnie z siostrą, na podwórku, w
  domu rodzinnym. Obecnie mieszka w miejscowości
  Trzcianka.`,

  CharactersSection5Title: "Teresa Tałaj",
  CharactersSection5Content: `Z Mikołajowa wyprowadziła się w latach 90. do
  miejscowości Osiek. Wspominała, że chętnie wróciłaby
  do wsi Mikołajów, razem ze wszystkimi ludźmi, których
  tam poznała. Zmarła we wrześniu 2021 roku.`,

  CharactersSection6Title: "Michał Tałaj",
  CharactersSection6Content: `Syn Teresy Tałaj. Z Mikołajowa wyprowadził się w
  latach 90. do miejscowości Osiek. Spędził w
  Mikołajowie całe swoje dzieciństwo. Nic nie przebije
  jego historii o Zaporożcu. Obecnie mieszka w
  miejscowości Trzcianka.`,
  TeamSection1Title: "@tarta_kolektyw",
  TeamSection1Content: `Grupa artystyczna powstała w maju 2021 r.
  Działalność kolektywu wpisuje się w nurt tzw. sztuki
  interaktywnej`,
  TeamSection2Title: `Angelika Gad "Cebula"`,
  TeamSection2Description: "koordynacja, scenariusz",
  TeamSection2Content: ` Entuzjastka polskiej wsi. Z zawodu UX/UI designerka.
  Po godzinach tworzy formy intermedialne.
  Zainteresowana nowymi technologiami i ich wpływem na
  sztukę. Absolwentka Dziennikarstwa na Uniwersytecie
  Jagiellońskim oraz Digital Designu na Wydziale
  Sztuki UP w Krakowie.`,
  TeamSection3Title: "Jakub Ciosiński",
  TeamSection3Description: "operator, montaż",
  TeamSection3Content: `Twórca filmowy, malkontent i wielki esteta. Wraz ze
  swoim dokumentalnym debiutem, podróżuje po polskich
  festiwalach filmowych. W chwilach natchnienia robi
  czarno-białe zdjęcia aparatem dziadka.`,
  TeamSection4Title: "Iga Filimowska",
  TeamSection4Description: "koordynacja, animacja",
  TeamSection4Content: `Grafik i animator. Interesuje się nietuzinkowymi
  wizualnie książkami. W ramach nagrody czyta komiksy
  i nałogowo słucha fantastyki. Chlubi się byciem
  działkowiczem, a ostatnio dużo przebywa w
  towarzystwie dinozaurów.`,
  TeamSection5Title: "Adam Grygierzec",
  TeamSection5Description: "udźwiękowienie",
  TeamSection5Content: `Pasjonat niszowych, hałaśliwych gatunków muzyki. Od
  2010 roku perkusista post punkowych kapel Alyson
  Vane, II Fala. Od 2018 roku produkuje muzykę
  elektroniczną jako P98. Członek krakowskiego
  kolektywu TECHNO TECHYES.`,

  TeamSection6Title: "Kinga Bożkiewicz",
  TeamSection6Description: "design",
  TeamSection6Content: `Absolwentka kierunków Digital Design i Art & Design.
  Miłośniczka brandingu, Szwajcarskich gridów i
  Polskiej Szkoły Plakatu. Na co dzień pracuje w
  Warszawskim studio Podpunkt jako brand designer.`,

  TeamSection7Title: "Sebastian Duran",
  TeamSection7Description: "3d",
  TeamSection7Content: `Absolwent Uniwersytetu Pedagogicznego na kierunku
  Art & Design. Na co dzień zajmuje się tworzeniem
  concept artów do gier, digital paintingiem i grafiką
  3d.`,

  TeamSection8Title: "Kamil Józefko",
  TeamSection8Description: "development",
  TeamSection8Content: "",
  "Special Thanks": "Podziękowania",
  "We thank everyone who supported this project.":
    "Dla wszystkich osób wspierających projekt.",
  SpecialThanksContent1: `Dziękujemy za pomoc w realizacji projektu Zarastanie,
  zarówno w sferze organizacyjnej, merytorycznej, jak i
  projektowej. Bez Waszego wsparcia nie bylibyśmy w
  stanie przekazać naszej idei w takiej formie, jak
  obecnie.`,
  SpecialThanksContent2: `Projekt zrealizowany w ramach programu
  artystyczno-badawczego Pracowni Narracji
  Interaktywnych i UX Design vnLAB.`,
  SpecialThanksContent3: `Projekt finansowany w ramach programu Ministra
  Edukacji i Nauki pod nazwą "Regionalna Inicjatywa
  Doskonałości" w latach 2019 - 2023 nr projektu
  023/RID/2018/19 w kwocie 11 865 100 zł.`,

  AboutTeamList1Title: "Produkcja",

  AboutTeamList2Title: "Producenci zarządzający",

  AboutTeamList3Title: "Producenci kreatywni",
  AboutTeamList3Content:
    "Katarzyna Boratyn, Krzysztof Pijarski (Pracownia Narracji Interaktywnych i UX Design vnLAB)",
  AboutTeamList4Title: "Główna koordynatorka vnLab",

  AboutTeamList5Title: "Obsługa administracyjna",

  AboutTeamList6Title: "Obsługa księgowa",

  AboutTeamList7Title: "Obsługa prawna",

  AboutTeamList8Title: "Finanse publiczne",

  AboutTeamList9Title: "Kierownicy Laboratorium Narracji Wizualnych vnLab",

  AboutTeamList10Title:
    "Archiwum Państwowe w Kielcach. Oddział zamiejscowy w Sandomierzu",
  AboutTeamList10Content: "Zdjęcia archiwalne",

  AboutTeamList11Title: "Ewa Drygalska",
  AboutTeamList11Content: "testy z użytkownikami",

  AboutTeamList12Title: "Nina Bażela",
  AboutTeamList12Content: "redakcja tekstów",

  AboutTeamList13Title: "Lauren Dubowski",
  AboutTeamList13Content: "tłumaczenia",

  AboutTeamList16Title: `Grupa Azoty Mines and Chemical Plants of Sulfur "Siarkopol" S.A.`,
  AboutTeamList17Title: "Szczególne podziękowania",
  AboutTeamList19Title: "Scenografia Intro",

  TutorialStep1: "1. Kliknij na przycisk i wybierz ścieżkę",
  TutorialStep2: "2. Kliknij na przycisk i oglądaj ścieżkę",
  TutorialStep3: "3. Kliknij w przycisk i przybliż pokoje",
  TutorialStep4: "4. Klikaj w zdjęcia i odkrywaj archiwa",
  TutorialStep5:
    "5. Kliknij na ikonę menu i zobacz dodatkowe informacje o projekcie",

  TutorialNextButton: "Dalej",
  Back: "Wróć",
  loaderText: "Trwa odbudowa wysiedlonej wsi, prosimy chwilę poczekać...",
  "Explore archives": "Odkryj archiwa",
  "Hide archives": "Ukryj archiwa",
  "The past": "Przeszłość",
  "The Displacement": "Wysiedlenie",
  "The present": "Teraźniejszość",
  Maintenance: "Obsługa techniczna",
  Copyright:
    "Copyright © 2022 PWSFTViT Państwowa Wyższa Szkoła Filmowa, Telewizyjna i Teatralna im. L. Schillera w Łodzi / vnLab. Wszelkie Prawa Zastrzeżone. Szkoła Filmowa w Łodzi (PWSFTViT) jest autorem niniejszego utworu na potrzeby Konwencji Berneńskiej i wszystkich przepisów praw krajowych nadających jej moc prawną, a także na potrzeby prawa autorskiego i innych praw.",
  HistoryOfMikolajow1Question:
    "Na jakim etapie jest obecnie proces naprawy terenu dawnego Mikołajowa?",
  HistoryOfMikolajow1Answer:
    "Na terenie dawnego Mikołajowa zasadzono las. Jest prowadzony proces naprawczy terenu i działania takie jak: odkwaszanie i&nbsp;poprawa właściwości gleby. Jesienią 2022 r. planowane jest zasadzenie większej ilości roślin, na terenie pokopalnianym.",
  HistoryOfMikolajow2Question:
    "Jak długo może trwać naprawa terenów po kopalni?",
  HistoryOfMikolajow2Answer:
    "Proces rekultywacji prowadzi się na kolejnych obszarach, na których zostało zakończone wydobycie siarki. Trwa on maksymalnie 5 lat od momentu zakończenia eksploatacji na danym terenie.",
  HistoryOfMikolajow3Question:
    "Czy istnieje szansa, że na teren Mikołajowa wrócą kiedyś mieszkańcy?",
  HistoryOfMikolajow3Answer:
    "Obecnie ze względu na przepisy prawne, w tym Miejscowy Plan Zagospodarowania Przestrzennego, nie jest możliwe osiedlenie mieszkańców na obszarach pozostałych po kopalni. Przepisy jednak mogą się zmienić i kto wie, co przyniesie ze sobą kolejne kilkanaście czy kilkadziesiąt lat.",
  HistoryOfMikolajow4Question:
    "Czy poddany naprawie obszar po kopalni może wrócić do dawnego ukształtowania terenu?",
  HistoryOfMikolajow4Answer:
    "Osiadanie gleby jest procesem nieodwracalnym, dlatego trudno mówić o powrocie do dawnej formy i&nbsp;ukształtowania terenu. Proces rekultywacji pozwoli jednak na ukształtowanie na nowo rzeźby terenu, odkwaszenie i odtworzenie gleby oraz przywrócenie terenom po kopalni wartości użytkowych i&nbsp;przyrodniczych.",
  mobileIntro1:
    "Załóż słuchawki i obejrzyj intro projektu, a tymczasem my popracujemy nad dalszą częścią wersji mobilnej.",
  mobileIntro2: "Zapraszamy do obejrzenia całości projektu na komputerze.",
};

export default plTranslation;
